// Ask the live preview to re-report what its geometry checks found.
//
// The deck side is shared/src/shell/checksRequest.js — read the note there for
// why this exists. Short version: the checks report on a state TRANSITION, so
// any studio surface that mounts after the slide settled hears nothing, and the
// Edit tab opened from a red badge showed an empty finding area next to a slide
// with a red box on it.
//
// Fire-and-forget by design. The answer comes back on the window 'message'
// channel every check already uses, so callers just listen as they always have;
// nothing here needs to know who is listening or how many of them there are.

import { CHECKS_REQUEST } from '@shared/shell/checksRequest';

/**
 * Ask every mounted check in this deck's preview for its current finding.
 *
 * Both preview buffers are on the channel (PreviewFrame is double-buffered and
 * either may be the visible one), and both answer — the reports carry `idx`, so
 * a listener filtering for its own slide is unaffected by the duplicate.
 */
export function requestSlideChecks(slug: string | null | undefined) {
  if (!slug || typeof BroadcastChannel === 'undefined') return;
  try {
    const ch = new BroadcastChannel(`deck-nav::/preview/${slug}/`);
    ch.postMessage({ type: CHECKS_REQUEST });
    ch.close();
  } catch {}
}
